import { Leaf } from "lucide-react";

// Uniform catalog image: renders inside a fixed aspect-ratio box (default square) with
// object-cover so every card matches. Falls back to a branded EYW placeholder when no image.
export default function CatalogImage({ src, alt = "", ratio = "square", className = "", rounded = "", testid = "catalog-image" }) {
  const aspect = ratio === "square" ? "aspect-square" : ratio === "video" ? "aspect-video" : ratio;
  return (
    <div className={`relative w-full ${aspect} overflow-hidden ${rounded} ${className}`} data-testid={testid}>
      {src ? (
        <img src={src} alt={alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
      ) : (
        <div className="absolute inset-0 grid place-items-center bg-gradient-to-br from-[#E7EEF1] via-[#F1EDE6] to-[#DDE7E0]" data-testid={`${testid}-placeholder`}>
          <Leaf className="text-[#144F75]/25" size="34%" strokeWidth={1.25} />
        </div>
      )}
    </div>
  );
}
